import {
  AfterContentChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  SecurityContext,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ModalBase } from '@components/modal/modal';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Cropper from 'cropperjs';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ImageCropperComponent extends ModalBase implements AfterContentChecked, OnDestroy {
  @ViewChild('container') private readonly imgContainer: ElementRef<HTMLDivElement>;
  @ViewChild('image') private readonly image: ElementRef<HTMLImageElement>;
  cropper: Cropper;
  imageUrl: SafeUrl = this.sanitizer.sanitize(SecurityContext.URL, URL.createObjectURL(this.file));

  constructor(
    @Inject('file') private readonly file: File,
    override readonly activeModal: NgbActiveModal,
    private readonly sanitizer: DomSanitizer,
  ) {
    super(activeModal);
    this.closeBtnLabel = $localize`Zatwierdź`;
    this.title = $localize`Kadrowanie obrazu`;
  }

  ngAfterContentChecked(): void {
    if (this.imgContainer && this.imgContainer.nativeElement.clientHeight && !this.cropper) {
      this.imgContainer.nativeElement.style.height = `${this.imgContainer.nativeElement.clientHeight - 48}px`;
      this.cropper = new Cropper(this.image.nativeElement, {
        autoCropArea: 1,
        highlight: false,
        modal: false,
        movable: false,
        responsive: true,
        scalable: false,
        viewMode: 2,
        zoomable: false,
      });
    }
  }

  ngOnDestroy(): void {
    if (this.cropper) {
      this.cropper.destroy();
    }
  }

  submit = (): void => {
    const htmlCanvasElement = this.cropper.getCroppedCanvas({ imageSmoothingEnabled: false });
    htmlCanvasElement.toBlob((blob) => {
      this.close({
        data: blob,
        dataUrl: this.sanitizer.sanitize(SecurityContext.URL, URL.createObjectURL(blob)),
      });
    }, this.file.type);
  };
}
